/* This file is autogenerated, see readme.md for instructions */
import ArrowLeftSvgIcon from '@bloomreach/banana-theme/icons/arrow-left.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const ArrowLeftIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <ArrowLeftSvgIcon />
    </Icon>
  );
});

ArrowLeftIcon.displayName = 'ArrowLeftIcon';

export default ArrowLeftIcon;
